export default __webpack_public_path__ + "static/media/report-score-service-location.41dd9749.svg";